module.exports =
{

  _init: function ()
  {
    this.onChangeItems()
    APPLICATION.PodConfigurator.modals.createPopup.setupModal("bedrooms")
  },

  onChangeItems: function ()
  {

    $('#bedrooms').not('.js-ignore').change(function ()
    {
      
      $(this).prop('disabled')
      APPLICATION.PodConfigurator.modals.createPopup.resetModal()
      APPLICATION._APPLICATION.customModal(
        '/pod-configurator/experience?modal=1&bedrooms=' + this.value,
        'PodConfigurator',
        'experienceModal'
      )

    }).addClass('js-ignore')

  }

}